export default async function dashboard (state) {
  const Support = (await import(/* webpackChunkName: 'component-support' */ '../../components/support')).default

  return new Support()
}
